import React, {useEffect} from 'react';
import {useHistory, useLocation} from 'react-router-dom';
import {useCurrentUser} from '../hooks/user';
import {fetchUserInfo} from '../store/user/actions';
import {useDispatch} from 'react-redux';
import {createOffersManagementUrl} from '../utils/navigation';
import {AlertType, NormalizedRoutes} from '../common/types';
import {openAppReviewDialog} from '../store/offers/reducers/actionDialogs';
import {ACTIVITY_FEED_PUSH_OPENED, getPushCategory, handlePushReceived} from '../common/nativePush';


interface IosPushNotifierProps {
}

const IosPushHandler: React.FC<IosPushNotifierProps> = () => {
  const history = useHistory();
  const dispatch = useDispatch();
  const userId = useCurrentUser()?.userId;
  const {pathname} = useLocation();
  const pushWindow = window as Window & {
    handlePushNotification?: (data: any) => void;
    __pendingPushNotifications?: any[];
  };

  const updateUserInfo = () => {
    dispatch(fetchUserInfo());
  }

  useEffect(() => {
    pushWindow.handlePushReceived = handlePushReceived;
    return () => {
      if (pushWindow.handlePushReceived === handlePushReceived) {
        pushWindow.handlePushReceived = data => {
          if (getPushCategory(data) === 'activity_feed') { pushWindow.__pendingActivityFeedRefresh = true; }
        };
      }
    };
  }, [pushWindow]);

  useEffect(() => {
    const pending = pushWindow.__pendingPushNotifications || [];
    pushWindow.__pendingPushNotifications = pending;

    const handlePush = (data: any) => {
      const category = getPushCategory(data);
      if (category === 'activity_feed') {
        // Keep a tap received during startup/login until the cabinet can show it.
        if (!userId || /^\/(login|registration|reset-password|restore-user)(\/|$)/.test(pathname)) {
          // Login can reload the document, so keep the target within this tab.
          try {
            sessionStorage.setItem('pendingActivityFeedPush', '1');
          } catch (error) {}
          pending.push(data);
          return;
        }
        try {
          sessionStorage.removeItem('pendingActivityFeedPush');
        } catch (error) {}
        if (pathname.replace(/\/$/, '') === NormalizedRoutes.ActivityFeed) {
          // The route is already mounted: navigation alone would not reload it.
          window.dispatchEvent(new Event(ACTIVITY_FEED_PUSH_OPENED));
          window.scrollTo(0, 0);
        } else {
          history.push(NormalizedRoutes.ActivityFeed);
        }
      } else {
        if (['payment', 'payment_gift', 'pro_subscription', 'status_level'].includes(category || '')) {
          dispatch(openAppReviewDialog(`push_${category}`));
        }
        if (category === 'payment') {
          history.push('/payment');
        }
      }
    };

    pushWindow.handlePushNotification = handlePush;
    pending.splice(0).forEach(handlePush);

    return () => {
      // Preserve taps between mounts and while React replaces the callback.
      if (pushWindow.handlePushNotification === handlePush) {
        pushWindow.handlePushNotification = data => pending.push(data);
      }
    };
  }, [dispatch, history, userId, pathname, pushWindow]);
  // @ts-ignore
  window.handleIosPaymentSuccess = function (data: any) {
    updateUserInfo();
    dispatch(openAppReviewDialog('ios_payment_success'));
    history.push(createOffersManagementUrl({alertType: AlertType.PaymentSuccessful, alertPayload: data}));
    console.log('Payment success received:', data);
  }
  return null;
};

export default IosPushHandler;
